'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _Albums = require('helpers/Albums');

var _Thumb = require('components/Thumb/Thumb');

var _Thumb2 = _interopRequireDefault(_Thumb);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var AlbumItemThumb = (_temp = _class = function (_PureComponent) {
  (0, _inherits3.default)(AlbumItemThumb, _PureComponent);

  function AlbumItemThumb() {
    (0, _classCallCheck3.default)(this, AlbumItemThumb);
    return (0, _possibleConstructorReturn3.default)(this, (AlbumItemThumb.__proto__ || (0, _getPrototypeOf2.default)(AlbumItemThumb)).apply(this, arguments));
  }

  (0, _createClass3.default)(AlbumItemThumb, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          className = _props.className,
          album = _props.album;


      return _react2.default.createElement(_Thumb2.default, { fileName: album.imageThumb, className: className, defaultImageName: (0, _Albums.getDefaultImageName)(album) });
    }
  }]);
  return AlbumItemThumb;
}(_react.PureComponent), _class.propTypes = {
  album: _propTypes2.default.object,
  className: _propTypes2.default.string
}, _class.defaultProps = {
  album: {}
}, _temp);
exports.default = AlbumItemThumb;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/AlbumItem/AlbumItemThumb/AlbumItemThumb.js
// module id = 813
// module chunks = 1